import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./VoucherList.css";

function VoucherList() {
  const location = useLocation();
  const navigate = useNavigate();
  const user = location.state?.user || {};

  console.log("User Data Received in VoucherList:", user); // 🛠 Debugging

  const [vouchers, setVouchers] = useState([]);
  const [selectedVoucher, setSelectedVoucher] = useState(null);
  const [pin, setPin] = useState("");
  const [showPinModal, setShowPinModal] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!user.user_id) {
      console.log("Redirecting: user_id is missing"); // 🛠 Debugging
      navigate("/user-dashboard");
      return;
    }

    console.log("Fetching vouchers for user:", user.user_id); // 🛠 Debugging

    fetch(`/api/user-vouchers/${user.user_id}`)
      .then((res) => res.json())
      .then((data) => {
        console.log("Fetched Vouchers:", data); // 🛠 Debugging
        setVouchers(data);
      })
      .catch((err) => console.error("Error fetching vouchers:", err));
  }, [user.user_id, navigate]);

  // Format Expiry Date to "DD (Full Month Name) YYYY"
  const formatDate = (dateString) => {
    if (!dateString) return "No Expiry";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    }); // Example: 16 February 2028
  };

  // Handle Redeem Button Click - Open PIN Modal
  const handleRedeemClick = (voucher) => {
    setSelectedVoucher(voucher);
    setShowPinModal(true);
  };

  // Handle PIN Submission
  const handlePinSubmit = async () => {
    if (pin.length !== 4) {
      setError("PIN must be 4 digits.");
      return;
    }

    try {
      const response = await fetch("/api/redeem-voucher", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          user_id: user.user_id,
          issued_voucher_id: selectedVoucher.issued_voucher_id,
          pin,
        }),
      });

      const result = await response.json();
      if (result.success) {
        alert("Voucher redeemed successfully!");
        setShowPinModal(false);
        setVouchers(vouchers.filter((v) => v.issued_voucher_id !== selectedVoucher.issued_voucher_id));
      } else {
        setError(result.error || "Invalid PIN. Please try again.");
      }
    } catch (error) {
      setError("Error processing redemption.");
    }
  };

  return (
    <div className="voucher-list-page">
      <h2>Available Vouchers</h2>

      {vouchers.length > 0 ? (
        vouchers.map((voucher) => (
          <div key={voucher.issued_voucher_id} className="voucher-card">
            <img
              src={voucher.voucher_image ? `https://www.bleusavr.com${voucher.voucher_image}` : "/fallback-image.jpg"}
              alt="Voucher"
              className="voucher-image"
              onError={(e) => { e.target.src = "/fallback-image.jpg"; }} // 🛠 Debugging
            />
            <div className="voucher-info">
              <h3>{voucher.voucher_type}</h3>
              <p><strong>Value:</strong> {voucher.voucher_value}</p>
              <p><strong>Expiry:</strong> {formatDate(voucher.expiry_date)}</p>
              <button className="redeem-btn" onClick={() => handleRedeemClick(voucher)}>
                Redeem
              </button>
            </div>
          </div>
        ))
      ) : (
        <p>No vouchers available. Try refreshing.</p> // 🛠 Debugging message
      )}

      {/* PIN Modal */}
        {showPinModal && (
          <div className="modal-overlay">
            <div className="modal-content">
              {/* Close Button (Top-Right) */}
              <button className="close-btn" onClick={() => setShowPinModal(false)}>✖</button>

              <h3>Enter Your 4-Digit PIN</h3>

              {/* Centered Input */}
              <div className="pin-input-container">
                <input
                  type="password"
                  maxLength="4"
                  value={pin}
                  onChange={(e) => setPin(e.target.value)}
                />
              </div>

              {error && <p className="error-text">{error}</p>}
              
              <button className="redeem-btn" onClick={handlePinSubmit}>Submit</button>
            </div>
          </div>
        )}

    </div>
  );
}

export default VoucherList;
